const solutions = [
  {
    title: "Run and deploy your apps, anywhere",
    text: "Avoid vendor lock-in with Eamico's commitment to open standards, hybrid, and multi-cloud infrastructure.",
    color: "#ff9a4d",
  },
  {
    title: "Make smarter decisions with real-time data",
    text: "Give your entire team access to analytics and performance insights with built-in monitoring and dashboards.",
    color: "#34a853",
  },
  {
    title: "Protect what's important",
    text: "Defend your applications against threats and attacks with enterprise-grade security included on every plan.",
    color: "#4285f4",
  },
  {
    title: "Collaborate from anywhere",
    text: "Real-time pair programming, shared environments, and integrated chat — your team, in sync.",
    color: "#ea4335",
  },
];

const SolutionsSection = () => {
  return (
    <section id="solutions" className="bg-white py-16 sm:py-20 lg:py-24" data-testid="solutions-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <h2 className="text-[28px] sm:text-[34px] lg:text-[40px] font-normal text-[#202124] leading-tight">
            Cloud computing,{" "}
            <span className="text-[#ff9a4d]">ready for business</span>
          </h2>
          <p className="mt-4 text-[15px] sm:text-base text-[#5f6368] leading-relaxed">
            Whether you're launching a startup or scaling to millions, we'll help you build and ship faster.
          </p>
          <div className="mt-6">
            <a href="#contact" className="inline-flex items-center px-5 py-2.5 text-[14px] font-medium text-[#ff9a4d] hover:text-[#e8872e] border border-[#dadce0] hover:border-[#ff9a4d] rounded-md transition-all" data-testid="solutions-talk-cta">
              Talk to us
            </a>
          </div>
        </div>

        {/* Cards */}
        <div className="grid sm:grid-cols-2 gap-5 lg:gap-6" data-testid="solutions-grid">
          {solutions.map((sol, i) => (
            <a
              key={i}
              href="#"
              className="group block p-8 bg-white rounded-xl border border-[#e8eaed] hover:border-[#dadce0] hover:shadow-md transition-all"
              data-testid={`solution-card-${i}`}
            >
              <div className="w-2 h-2 rounded-full mb-5" style={{ backgroundColor: sol.color }} />
              <h3 className="text-[18px] sm:text-[20px] font-medium text-[#202124] mb-3 leading-snug group-hover:text-[#ff9a4d] transition-colors">
                {sol.title}
              </h3>
              <p className="text-[14px] text-[#5f6368] leading-relaxed">
                {sol.text}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
